import { createFeature, createReducer, on } from '@ngrx/store';

import { UserManagementActions } from './user-management.actions';
import { initialUserManagementState } from './user-management.state';

export const userManagementFeature = createFeature({
  name: 'portalUserManagement',
  reducer: createReducer(
    initialUserManagementState,
    on(UserManagementActions.loadUser, (state) => ({
      ...state,
      loadingDetail: true,
      selectedUser: null,
      roleDetails: {},
      error: null,
    })),
    on(UserManagementActions.loadUserSuccess, (state, { user, roles, policies }) => ({
      ...state,
      selectedUser: user,
      roleDetails: roles,
      policyDetails: { ...state.policyDetails, ...policies },
      loadingDetail: false,
    })),
    on(UserManagementActions.loadUserFailure, (state, { error }) => ({
      ...state,
      loadingDetail: false,
      error,
    })),
    on(UserManagementActions.loadPolicy, (state) => ({
      ...state,
      loadingPolicy: true,
      error: null,
    })),
    on(UserManagementActions.loadPolicySuccess, (state, { policy }) => ({
      ...state,
      loadingPolicy: false,
      policyDetails: { ...state.policyDetails, [policy.id]: policy },
    })),
    on(UserManagementActions.loadPolicyFailure, (state, { error }) => ({
      ...state,
      loadingPolicy: false,
      error,
    })),
    on(UserManagementActions.updateUser, (state) => ({
      ...state,
      submitting: true,
      error: null,
      successMessage: null,
    })),
    on(UserManagementActions.updateUserSuccess, (state, { user, roles, policies, message }) => ({
      ...state,
      selectedUser: user,
      roleDetails: roles,
      policyDetails: { ...state.policyDetails, ...policies },
      submitting: false,
      successMessage: message,
    })),
    on(UserManagementActions.updateUserFailure, (state, { error }) => ({
      ...state,
      submitting: false,
      error,
    })),
    on(UserManagementActions.setUserStatus, (state) => ({
      ...state,
      updatingStatus: true,
      error: null,
      successMessage: null,
    })),
    on(UserManagementActions.setUserStatusSuccess, (state, { active, message }) => ({
      ...state,
      updatingStatus: false,
      selectedUser: state.selectedUser
        ? { ...state.selectedUser, status: active ? 'ACTIVE' : 'INACTIVE' }
        : null,
      successMessage: message,
    })),
    on(UserManagementActions.setUserStatusFailure, (state, { error }) => ({
      ...state,
      updatingStatus: false,
      error,
    })),
    on(UserManagementActions.clearSelectedUser, (state) => ({
      ...state,
      selectedUser: null,
      roleDetails: {},
      loadingDetail: false,
      error: null,
      successMessage: null,
    })),
    on(UserManagementActions.clearFeedback, (state) => ({
      ...state,
      error: null,
      successMessage: null,
    })),
  ),
});

export const {
  selectSelectedUser,
  selectRoleDetails,
  selectPolicyDetails,
  selectLoadingDetail,
  selectLoadingPolicy,
  selectSubmitting,
  selectUpdatingStatus,
  selectError,
  selectSuccessMessage,
} = userManagementFeature;
